

import { Link } from "react-router-dom"
import SliderVol from "./SliderVol"
import LimitOrder from "./LimitOrder"
import MarketOrder from "./MarketOrder"
import SpotOrder from "./SpotOrder"






export default function FormOrders({customCoin,witchItem,coinBy,isAuth,handleChooseBalanceClick,separateNum,selected,coinsChoose,coinBalance,setCoinBalance,processing,priceAmount,KARMOZD,quoteCoinIncrement,handelSubmitBuy,buttonClicked,userBalance,setUserBalance,setProcessing,handelSubmitSell,teterPriceSell,baseCoinIncrement,findBalance}){












    return(

        <>

        {witchItem == 'buy' ? 
        <>

        {selected == 1 &&

<MarketOrder customCoin={customCoin} witchItem={witchItem} coinBy={coinBy} isAuth={isAuth} handleChooseBalanceClick={handleChooseBalanceClick} separateNum={separateNum} selected={selected} coinsChoose={coinsChoose} coinBalance={coinBalance} processing={processing} setProcessing={setProcessing} priceAmount={priceAmount} KARMOZD={KARMOZD} quoteCoinIncrement={quoteCoinIncrement} handelSubmitBuy={handelSubmitBuy} buttonClicked={buttonClicked} userBalance={userBalance} setUserBalance={setUserBalance} setCoinBalance={setCoinBalance} findBalance={findBalance}/>




    }

    {selected == 2 &&
    
  <LimitOrder customCoin={customCoin} witchItem={witchItem} coinBy={coinBy} isAuth={isAuth} handleChooseBalanceClick={handleChooseBalanceClick} separateNum={separateNum} selected={selected} coinsChoose={coinsChoose} coinBalance={coinBalance} processing={processing} setProcessing={setProcessing} priceAmount={priceAmount} KARMOZD={KARMOZD} quoteCoinIncrement={quoteCoinIncrement} handelSubmitBuy={handelSubmitBuy} buttonClicked={buttonClicked} userBalance={userBalance} setUserBalance={setUserBalance} setCoinBalance={setCoinBalance} findBalance={findBalance}/>
    
    }



    {selected == 3 && 

<SpotOrder customCoin={customCoin} witchItem={witchItem} coinBy={coinBy} isAuth={isAuth} handleChooseBalanceClick={handleChooseBalanceClick} separateNum={separateNum} selected={selected} coinsChoose={coinsChoose} coinBalance={coinBalance} processing={processing} setProcessing={setProcessing} priceAmount={priceAmount} KARMOZD={KARMOZD} quoteCoinIncrement={quoteCoinIncrement} handelSubmitBuy={handelSubmitBuy} buttonClicked={buttonClicked} userBalance={userBalance} setUserBalance={setUserBalance} setCoinBalance={setCoinBalance} findBalance={findBalance}/>

    
    
    
    }
    

        </>


    :
    <>

    {selected == 1 &&

<MarketOrder customCoin={customCoin} witchItem={witchItem} coinBy={coinBy} isAuth={isAuth} handleChooseBalanceClick={handleChooseBalanceClick} separateNum={separateNum} selected={selected} coinsChoose={coinsChoose} coinBalance={coinBalance} processing={processing} setProcessing={setProcessing} priceAmount={priceAmount} KARMOZD={KARMOZD} quoteCoinIncrement={quoteCoinIncrement} handelSubmitBuy={handelSubmitBuy} buttonClicked={buttonClicked} userBalance={userBalance} setUserBalance={setUserBalance} findBalance={findBalance}/>


}

{selected == 2 &&

<LimitOrder customCoin={customCoin} witchItem={witchItem} coinBy={coinBy} isAuth={isAuth} handleChooseBalanceClick={handleChooseBalanceClick} separateNum={separateNum} selected={selected} coinsChoose={coinsChoose} coinBalance={coinBalance} processing={processing} setProcessing={setProcessing} priceAmount={priceAmount} KARMOZD={KARMOZD} quoteCoinIncrement={quoteCoinIncrement} handelSubmitBuy={handelSubmitBuy} buttonClicked={buttonClicked} userBalance={userBalance} setUserBalance={setUserBalance} findBalance={findBalance}/>

}



{selected == 3 && 

<SpotOrder customCoin={customCoin} witchItem={witchItem} coinBy={coinBy} isAuth={isAuth} handleChooseBalanceClick={handleChooseBalanceClick} separateNum={separateNum} selected={selected} coinsChoose={coinsChoose} coinBalance={coinBalance} processing={processing} setProcessing={setProcessing} priceAmount={priceAmount} KARMOZD={KARMOZD} quoteCoinIncrement={quoteCoinIncrement} handelSubmitBuy={handelSubmitBuy} buttonClicked={buttonClicked} userBalance={userBalance} setUserBalance={setUserBalance} setCoinBalance={setCoinBalance} findBalance={findBalance}/>

    
    
    
    }

    </>

    }



    </>
    
    )
}